import React from "react";
import {FormattedMessage} from "react-intl";
import Checkbox from "../ui-components/Checkbox";

const SuggestedUsersOnlyExcludeNullsFilter =
  ({
     columnDef,
     onFilterChanged,
     onChangeExcludeNulls
   }) => {
  const [checked, setChecked] = React.useState(false);
  return (
    <div>
      <Checkbox
        checked={checked}
        onChange={(e) => {
          setChecked(e.target.checked)
          onChangeExcludeNulls(e.target.checked)
          onFilterChanged((columnDef).tableData.id, null);
        }}
        style={{marginRight: "1rem"}}
      />
      <FormattedMessage id="exclude_nulls" defaultMessage={"rimuovi celle vuote"}/>
    </div>
  )
}

export default SuggestedUsersOnlyExcludeNullsFilter;